/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form data factories for Hot Desking module.
────────────────────────────────────────────────────────────────*/

import { DEFAULT_LANGUAGE_CODE } from '../../../data/formOptions';
import type { HotDeskFormState } from '../types';
import { generateDefaultSecret } from './passwordGenerators';

const DEFAULT_MAX_REGISTRATIONS = '5';
const DEFAULT_CODECS = 'PCMU,PCMA';
const DEFAULT_DTMF_MODE = 'rfc4733';

/**
 * Creates default hot desk form data
 */
export function createDefaultFormData(): HotDeskFormState {
  return {
    username: '',
    password: generateDefaultSecret(),
    description: '',
    sipProfileId: null,
    dispatchLocationId: null,
    maxRegistrations: DEFAULT_MAX_REGISTRATIONS,
    outboundCodecs: DEFAULT_CODECS,
    inboundCodecs: DEFAULT_CODECS,
    dtmfMode: DEFAULT_DTMF_MODE,
    language: DEFAULT_LANGUAGE_CODE,
    enabled: true,
  };
}


